import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'

import Modal from '../../common/Modal'
import SubmitButton from '../../common/buttons/SubmitButton'
import ButtonLink from '../../common/buttons/ButtonLink'

import classes from './CommunityLandingPageTab.module.scss'
import { ReactComponent as Icon } from '../../../assets/images/common/icons/golfer-half-icon-round.svg'

const ConfirmationModal = (props) => {
  const { t } = useTranslation()
  const communityId = useSelector(state => state.communitySettings.landingPage.community.id)

  return (
    <Modal fixedTop {...props}>
      <div className='d-flex flex-column align-items-center px-3'>
        <Icon className='mb-3'/>
        <h2 className={classes['confirmation-modal-title']}>{t('communitySettings.landingPage.confirmModal.title')}</h2>
        <p className='text-center font-weight-bold'>{t('communitySettings.landingPage.confirmModal.message')}</p>
        <ButtonLink navigateTo={`/landing/${communityId}`} target='_blank'>
          {t('communitySettings.landingPage.confirmModal.viewLandingPage')}
        </ButtonLink>
        <SubmitButton
          type='button'
          buttonColor='navy-button'
          buttonMessage={t('communitySettings.landingPage.confirmModal.done')}
          onClick={props.onClose}
        />
      </div>
    </Modal>
  )
}

ConfirmationModal.propTypes = {
  onClose: PropTypes.func,
}

export default ConfirmationModal
